export default __webpack_public_path__ + "static/media/masterCardIcon.e2811d07.png";